import React, { useEffect } from 'react';

// Popover over baren, forankret til sit anker (forælderen skal være position: relative): usynlig scrim bag,
// × og Escape lukker, og en lille caret peger på ankeret. Ikke en fuldskærms-modal.
export default function Popover({ title, onClose, width, left = 0, caretLeft = 40, children }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <>
      <div className="fixed inset-0" style={{ zIndex: 2001 }} onClick={onClose} aria-hidden="true" />
      <div
        role="dialog"
        aria-label={typeof title === 'string' ? title : undefined}
        className="absolute text-white"
        style={{
          left, bottom: 'calc(100% + 18px)', width, zIndex: 2002, padding: 14, background: '#0D1A27',
          border: '1px solid #273C61', borderRadius: 8, boxSizing: 'border-box', animation: 'zrmPop .25s ease-out', transformOrigin: `${caretLeft}px 100%`,
        }}
      >
        <div className="flex items-center justify-between" style={{ marginBottom: 12 }}>
          <span className="font-bold" style={{ fontSize: 14, lineHeight: '18px' }}>{title}</span>
          <button onClick={onClose} className="text-white/60 hover:text-white" aria-label="Close">
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {children}
        <span
          aria-hidden="true"
          style={{ position: 'absolute', left: caretLeft, bottom: -6, width: 10, height: 10, background: '#0D1A27', borderRight: '1px solid #273C61', borderBottom: '1px solid #273C61', transform: 'rotate(45deg)' }}
        />
      </div>
    </>
  );
}
